var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcCirclePlay(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.33337 3.33336C3.3333 3.09876 3.39514 2.86829 3.51263 2.66522C3.63012 2.46216 3.79911 2.29369 4.00254 2.17683C4.20597 2.05996 4.43663 1.99885 4.67123 1.99964C4.90584 2.00044 5.13608 2.06312 5.33871 2.18136L13.3367 6.8467C13.5385 6.96382 13.7061 7.13186 13.8227 7.33403C13.9392 7.5362 14.0007 7.76543 14.0009 7.99879C14.0011 8.23215 13.94 8.46148 13.8238 8.66385C13.7076 8.86623 13.5403 9.03456 13.3387 9.15203L5.33871 13.8187C5.13608 13.9369 4.90584 13.9996 4.67123 14.0004C4.43663 14.0012 4.20597 13.9401 4.00254 13.8232C3.79911 13.7064 3.63012 13.5379 3.51263 13.3348C3.39514 13.1318 3.3333 12.9013 3.33337 12.6667V3.33336Z",
    stroke: "white",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCirclePlay);
export default __webpack_public_path__ + "static/media/ic_circle_play.4fdfa1698d195e26a1bc83c29ca9bf96.svg";
export { ForwardRef as ReactComponent };